export default "__VITE_ASSET__CPLlOsoV__"